import "../i18n";

import afiliatePage from "assets/images/affiliate-page.png";

import PATH from "./path";
// import { ReactComponent as MemberVipIcon } from "assets/Common/icons/icon-member-vip.svg";

export interface HeaderMenuStyle {
  icon: any;
  label: string;
  link: string;
  iconImage?: string;
}

export const headerMenu: HeaderMenuStyle[] = [
  { icon: afiliatePage, label: "Affiliate", link: PATH.affiliate }
];
